/**
 * useAuthEnabled.js
 * Echter Auth-Hook für Dynamic SDK v4
 * Wird nur importiert wenn Auth aktiviert ist
 */
import { useDynamicContext, useIsLoggedIn, getAuthToken } from '@dynamic-labs/sdk-react-core';

export function useAuthEnabled() {
  const {
    user,
    primaryWallet,
    handleLogOut,
    setShowAuthFlow,
  } = useDynamicContext();

  const isLoggedIn = useIsLoggedIn();

  return {
    // Auth-State
    isLoggedIn,
    isLoading: user === undefined && !isLoggedIn,

    // User-Daten (vereinfacht)
    user: user ? {
      id: user.userId,
      walletAddress: primaryWallet?.address || null,
      email: user.email || null,
      // Username aus Dynamic "Additional User Information"
      username: user.username || null,
      // Login-Methode (google, discord, wallet, etc.)
      provider: user.verifiedCredentials?.[0]?.oauthProvider || 'wallet',
    } : null,

    // Aktionen
    openLogin: () => setShowAuthFlow(true),
    logout: handleLogOut,

    // Token für Backend-Calls (SDK v4: direct import)
    getAuthToken,

    // Wallet (falls direkt benötigt)
    wallet: primaryWallet,
  };
}
